<template>
    <div>
        <loading-component :value="loading"></loading-component>
        <v-card>
            <div v-if="provider === 'captain'">
                <h4>You cannot approve captain without register receiving 0 S.P, choose cash register which you want
                    to add them to:</h4>
                <v-select v-model="cash_register_id" item-value="id" item-text="name" :items="cash_registers"
                          label="Choose cash register"></v-select>
            </div>
            <h4 style="text-align: center">Are you sure you want to approve this {{provider}}?</h4>
            <h2 style="text-align: center">make sure that all info are correct, its your responsibility!</h2>
        </v-card>
    </div>
</template>

<script>
    import LoadingComponent from "@/components/LoadingComponent";

    export default {
        name: "SummaryInfo",
        components: {LoadingComponent},
        props: ['id', 'provider'],
        data() {
            return {
                loading: false,
                cash_registers: [],
                cash_register_id: null,
            }
        },
        mounted() {
            if (this.provider === 'captain') {
                this.loading = true;
                this.axios.get('cash_registers')
                    .then(res => this.cash_registers = res.data.data)
                    .catch(err => console.log(err.message))
                    .finally(() => this.loading = false);
            }
        },
        methods: {
            reset() {
            },
            update() {
            },
            submit() {
                if (!this.cash_register_id && this.provider === 'captain') {
                    window.getApp.$emit("SHOW_TOAST", 'Choose cash register please', "red", ['center', 'top']);
                    return;
                }
                this.loading = true;
                this.axios.put(`${this.provider}/${this.id}/active`, {cash_register_id: this.cash_register_id})
                    .then(() => {
                        window.getApp.$emit("SHOW_TOAST", 'Activation completed successfully', "green", ['center', 'top']);
                        this.$emit('next_step');
                        this.$emit('approved', this.id);
                    })
                    .catch(err => {
                        try {
                            if (err.response.data.message) {
                                window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red", ['center', 'top']);
                            } else {
                                window.getApp.$emit("SHOW_TOAST", err.message, "red", ['center', 'top']);
                            }
                        } catch (e) {
                            console.log(err.message, e.message);
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                        this.$emit('done');
                    });
            }
        }
    }
</script>

<style scoped>

</style>